<template>
  <a-banner
    v-if="bannerSettings.TOP_SIDE"
    :banner-settings="bannerSettings.TOP_SIDE"
    :custom-breakpoint-handler="wideSkyBreakpointHandler"
    class="above-header-meta-content"
    :class="bannerDynamicClass"
    @campaign-is-empty-status="onBannerCampaignIsEmptyStatusChange"
  />
</template>

<script>
import ABanner from 'shared/ABanner/index.vue'
import { BANNER_SETTINGS_BY_ROUTE_NAME } from 'enums/banners/banner-settings-by-route-name'
import {
  WIDE_SKY_BANNERS_BREAKPOINT_NAME,
  WIDE_SKY_BANNERS_BREAKPOINT_VALUE
} from 'enums/banners/banner-settings'

export default {
  name: 'TopBanner',
  components: { ABanner },
  data() {
    return {
      isCampaignVisible: false
    }
  },
  computed: {
    bannerSettings() {
      return BANNER_SETTINGS_BY_ROUTE_NAME[this.$route.name] || {}
    },
    bannerDynamicClass() {
      return {
        'campaign-visible': this.isCampaignVisible
      }
    }
  },
  methods: {
    wideSkyBreakpointHandler(width) {
      if (width >= WIDE_SKY_BANNERS_BREAKPOINT_VALUE) {
        return WIDE_SKY_BANNERS_BREAKPOINT_NAME
      }

      return null
    },
    onBannerCampaignIsEmptyStatusChange(value) {
      this.isCampaignVisible = !value
    }
  }
}
</script>

<style lang="scss">
.above-header-meta-content {
  background: $c--header;

  $margin: (
    $above-desktop-xl: 0,
    // do not remove, it overrides the mobile-specific component-level styles
      $mobile: 0
  );

  $padding: (
    $above-desktop-xl: 0 0 15px 0
  );

  @include setStyleByBreakpoint('margin', $margin);
  @include setStyleByBreakpoint('padding', $padding);

  .banner__info {
    margin: 15px 0;
  }

  &.campaign-visible .banner > div {
    position: relative;

    $min-width: (
      $above-desktop-xl: 728px,
      $desktop-lg: unset
    );

    @include setStyleByBreakpoint('min-width', $min-width);

    &::before {
      @include textTiny;

      white-space: nowrap;
      position: absolute;
      content: 'Advertisement';
      left: -11px;
      top: 50%;
      transform: rotate(270deg) translate(-50%, -50%);
      transform-origin: left top;
      color: rgba($c--white, 0.5);

      @include tablet {
        display: none;
      }
    }
  }

  &.empty {
    @include mobile {
      padding-bottom: 0;
    }

    .banner::before {
      display: none;
    }
  }
}
</style>
